import React, { useRef, createRef } from "react";
import PopupApcode from "./../PopUp/PopUpApcode";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import PopUpOther, { CreditCode } from "./../PopUp/PopUpOther";
import { parseJwt } from "./../parseJWT";
import SelectFix, { SelectFix_UNIT } from "./../PopUp/SelectFix";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { DropdownButton, MenuItem, Row, Col, Panel } from "react-bootstrap";
import PopUpItem from "./../PopUp/PopUpItem";
import PopUpwarehouse from "./../PopUp/PopUpwarehouse";
import PopUpSaveMoneyExp from "./../PopUp/PopUpSaveMoneyExp";
import { ReDate } from "./../PopUp/PopUpSearchDoc";
import Rechecked from "./component/Rechecked";
import PopUpRefDocno from "./../PopUp/PopUpRefDocno";
import { checkData } from "../_source/checkDatainput";
import { checkunit } from "../_source/checkUnit";
import axios from "axios";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import CheckBranchname from "../CustomFunction/Branch/Checkname";
import SelectDatas from "./../PopUp/SelectData";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import CustomInputtext from "./../Components/CustomInput/Inputtext";
import Moment from "moment";
import Checkwarehousepermission from "./../CustomFunction/STKwarehouse/Checkwarehousepermission";
import UseAutocompletes from "../Components/CustomInput/UseAutocompletes";

import CustomInput from "../Components/CustomInput/CustomInput";
import { Grid } from "@mui/material";

//"../CustomFunction/STKwarehouse/Checkwarehousepermission";
const rowTable = 300;
const _menuItem = { margintop: 10 };
const defaultcode = "0";
const listmenu = [
  ["เลือกใบขอสั่งซื้อสินค้า (PR)", "SelPRRef"],
  ["บันทึกจ่ายเงิน", "MoneyExp"],
];
export default class index extends React.Component {
  constructor(props) {
    super(props);
    this.TaxPersens = createRef();
    this.DiscountPersen = createRef();
    this.Department = createRef();
    this.TaxNumber = createRef();
    this.Branch_code = createRef();
    this.Branch = createRef();
    this.DeliNumber = createRef();
    this.Discount = createRef();
    this.ProductValue = createRef();
    this.REMARK = createRef();
    this.TaxPrice = createRef();
    this.PS_Chassisnumber = createRef();
    this.PS_Serialnumber = createRef();
    this.Kilo_metter = createRef();
    this.EventType = createRef();
    this.APCode = createRef();
    this.Groupdata = createRef();
    this.APName = createRef();
    //this.customercodetr = createRef()
    this.CreditCode_code = createRef();
    this.Department_code = createRef();
    this.WTAXAMOUNT = createRef();
    this.depositpayment = createRef();
    this.Groupdata_code = createRef();
    this.SumPrice = createRef();
    this.valueTax = createRef();
    this.TotalPrice = createRef();
    this.ValueExcept = createRef();
    this.SaleMan_code = createRef();
    this.SaleMan = createRef();
    this.CreditCode = createRef();
  }
  state = {
    siteCodeUser: "",
    _saveStatus: "",
    DOCGROUP_code: "",
    DOCGROUP_txt: "",
    Department_code: "",
    Department_txt: "",
    Branch_code: "",
    SiteCode_txt: "",
    openBackdrop: false,
    OpenBuyDate: false,
    isLoading: false,
    messagealert: false,
    color1: "ค้นหาสี...",
    Credit: "",
    Creditsum: "",
    Income: "",
    Incomesum: "",
    Expenses: "",
    Expensessum: "",
    PROJECT: "",
    PriceType_code: defaultcode,
    defaultselect: defaultcode,
    BuyType_code: ["0"],
    checkenableInput: [],
    defaultvaluewarehouse: "",
    defaultwarehouse: "",
    defaultlocetion: "",
    //เงินทดรองจ่าย
    ADVANCEPAYBAL: "",
    typeActoin: "new",
    //-------------------  recheck ----------------------------------
    RecheckedDocno: "",
    rescspurchase: [],

    //-------------------- endrececk  start autocomplete--------------------------------------
    choicebrandData: [],
    choicemodelData: [],
    choicecolorData: [],
    typeLoad: "",
    carnumber: [],
    //-------------------- end autocomplete--------------------------------------
  };
  async componentDidMount() {
    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });
    console.log(
      "JSON.parse(localStorage.getItem('checkoftxt'))",
      JSON.parse(localStorage.getItem("checkoftxt"))
    );

    this.setRow(rowTable);
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.onAddValue("Branch", SITECODESTR.User.SITECODE, "");

    // this.TaxPersens.current.value = '7.00'
    // this.DiscountPersen.current.value = parseFloat(0).toFixed(2)
    this.setState({
      siteCodeUser: SITECODESTR.User.SITECODE,
      CASHAMOUNT: 0.0,
      userCode: SITECODESTR.User.CODE,
    });
    if (localStorage.getItem) {
      this.onAddValue("SaleMan", SITECODESTR.User.CODE);
      this.setState({ selectedbrandname: "_code[0].trim()" });
    }
    setTimeout(() => {
      this.Branch_code.current.value = SITECODESTR.User.SITECODE;
    }, 100);
  }
  ResetThisPage() {
    window.location.reload();
  }
  escapeRegExp(str) {
    return str.replace(/,/g, " ");
  }
  _connectsaveData = () => {
    let groupdatachk;
    if (this.APCode.current.value === "" && this.state.APCODE === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลรหัสเจ้าหนี้" });
      return;
    } else if (this.Groupdata.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลกลุ่มข้อมูล" });
      return;
    } else if (checkData("text", this.state.products[0].productcode) === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลรายการสินค้า" });
      return;
    } else {
      //--------------------------เช็คกลุ่มข้อมูล
      groupdatachk = String(this.Groupdata.current.value.match(/เคลม/gi));
      console.log("groupdatachk", groupdatachk);

      if (groupdatachk === "เคลม") {
        //เช็คที่เก็บในตาราง
        this.checklocation().then((res) => {
          if (res === true) {
            if (
              this.CreditCode_code.current.value === "C00" &&
              Number(this.TotalPrice.current.value) > 0
            ) {
              this.setState({ typeFullScreenDialog: "MoneyExp" });
              this.setState({ titleFullScreenDialog: "บันทึกจ่ายเงิน" });
              this.setState({ openFullScreenDialog: true });
            } else {
              this.saveData();
            }
          }
        });
        return;
      } else {
        // console.log("groupdatachk", this.TaxNumber.current.value, "this.PriceType_code:::", this.state.PriceType_code)
        if (
          this.TaxNumber.current.value.trim() === "" &&
          this.state.PriceType_code !== "2"
        ) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกข้อมูลใบกำกับภาษี" });
          return;
        } else {
          if (
            this.CreditCode_code.current.value === "C00" &&
            Number(this.TotalPrice.current.value) > 0
          ) {
            // this.setState({ PopUpSaveMoney: !this.state.PopUpSaveMoney })
            this.setState({ typeFullScreenDialog: "MoneyExp" });
            this.setState({ titleFullScreenDialog: "บันทึกจ่ายเงิน" });
            this.setState({ openFullScreenDialog: true });
          } else {
            this.saveData();
          }
        }
        return;
      }
    }
  };
  checklocation = async () => {
    let res = true;
    for (let index = 0; index < this.state.products.length; index++) {
      let loc = this.state.products[index].location;
      if (
        this.state.products[index].productcode !== "" ||
        typeof this.state.productcode !== "undefined"
      ) {
        if (typeof loc !== "undefined" && loc.slice(loc.length - 1) < 3) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บให้ถูกต้อง" });
          res = false;
          return;
        }
      }
      return await res;
    }
  };
  get_PopUpSaveMoney = async (
    cash,
    cchqsarr,
    csrexpensesarr,
    csrecincomarr
  ) => {
    let Cchqssum = 0;
    let Expensessum = 0;
    let Incomesum = 0;
    await cchqsarr.forEach((element) => {
      Cchqssum += Number(element.Chqamount);
    });
    await csrexpensesarr.forEach((element) => {
      Expensessum += Number(element.Expensesamount);
    });
    await csrecincomarr.forEach((element) => {
      Incomesum += Number(element.IncomeAmount);
    });
    await this.setState({
      CashReceipt: cash[0].Cashbalance, //เงินสด
      Bookno: cash[0].Bookno, //เลขบัญชี
      Bankamount: cash[0].Bankamount, //ยอดเงินโอน
      Bankexpend: cash[0].Bankexpend, //ค่าธรรมเนียมจ่ายหักบัญชี
      Bookdesc: cash[0].Transferremark,

      Advanceamount: cash[0].Advanceamount,
      Pettycashcode: cash[0].Pettycashcode,
      Pettycash: cash[0].Pettycashvalue,
    });
    await this.saveData();
  };
  saveData = async () => {
    // checkData(type, data)
    // text => ข้อมูลที่เป็นข้อความ
    // money => ข้อมูลที่เป็นยอดเงิน
    // number => ตัวเลขจำนวนเต็ม
    const parameter = new URLSearchParams();
    let dateTAX = this.state.TexDate.split("/");
    dateTAX =
      dateTAX[2] - 543 + "-" + dateTAX[1] + "-" + dateTAX[0] + " 00:00:00.000";
    let dataTT = [];
    var s = [];

    console.log("this.state.products", this.state.products);

    for (
      var i = 0;
      i < this.state.products.length && this.state.products[i].productcode;
      i++
    ) {
      // if (
      //   this.state.products[i].productcode[0] + "" + this.state.products[i].productcode[1] ===
      //   "11" &&
      //   !this.state.products[i].SERIALNUMBER
      // ) {
      //   this.setState({ opensnackbar: true })
      //   this.setState({ color: "warning" })
      //   this.setState({ icon: ErrorIcon })
      //   this.setState({ messagealert: "กรุณาระบุ SERIALNUMBER" })
      //   return
      // }

      if (this.state.products[i].productcode !== "") {
        let discount =
          this.state.products[i].discount === undefined
            ? ""
            : this.state.products[i].discount;
        dataTT.push({
          productcode: this.state.products[i].productcode, //0 รหัสสินค้า
          productname: this.state.products[i].productname, //1 ชื่อสินค้า
          warehouse: this.state.products[i].warehouse, //2 คลัง
          location: this.state.products[i].location, //3 ตำแหน่งเก็บ
          unitcode: this.state.products[i].unitcode, //4 หน่วย
          quantity: this.state.products[i].quantity, //5 ปริมาณ
          buyprice: this.state.products[i].buyprice, //6 ราคาซื้อ
          discountword: this.state.products[i].discountword, //7 ลด
          discount: discount, // 8ลด(จำนวนเงิน)
          amount: this.state.products[i].amount, //9 จำนวนเงิน
          itemtaxtype: this.state.products[i].itemtaxtype, //10 ประเภทราคาที่มากะรหัส
          refDocno: this.state.products[i].RefDocno
            ? this.state.products[i].RefDocno
            : "", //11  มาจาก popup ค้นหาใบขอสั่งซื้อสินค้า-SelPRRef
          refqty: this.state.products[i].REFQTY
            ? this.state.products[i].REFQTY
            : "", //12 มาจาก popup ค้นหาใบขอสั่งซื้อสินค้า-SelPRRef
          reflineid: this.state.products[i].REFLINEID
            ? this.state.products[i].REFLINEID
            : "", //13  มาจาก popup ค้นหาใบขอสั่งซื้อสินค้า-SelPRRef
          refdoctype: this.state.products[i].REFDOCTYPE
            ? this.state.products[i].REFDOCTYPE
            : "", //14
        });
        // s.push(dataTT[i])
      }
    }
    /* Success */
    parameter.append("listitem", JSON.stringify(dataTT));
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("APNAME", this.APName.current.value);
    parameter.append("APCODE", this.APCode.current.value.trim());
    parameter.append(
      "TAXNO",
      this.TaxNumber.current.value.trim() /* this.state.PriceType_code !== "2" ? this.TaxNumber.current.value : "" */
    );
    var POSTBALANCE = "";
    if (Number(this.state.Bankexpend) > 0) {
      POSTBALANCE = "0";
    }
    if (Number(this.state.Creditsum) > 0) {
      POSTBALANCE = "0";
    }
    if (Number(this.state.Incomesum) > 0) {
      POSTBALANCE = "0";
    }
    console.log(Number(this.state.Expensessum));
    if (Number(this.state.Expensessum) > 0) {
      POSTBALANCE = "0";
    }
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("DocDate", this.state.BuyDate);
    parameter.append("CREDITCODE", this.CreditCode_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("REMARK", checkData("text", this.REMARK.current.value));
    parameter.append("SUMAMOUNT1", this.SumPrice.current.value);
    parameter.append(
      "DISCWORD",
      this.DiscountPersen.current.value
        ? this.DiscountPersen.current.value + "%"
        : ""
    );
    parameter.append("AFTERDISC", this.ProductValue.current.value);
    parameter.append("TAXRATE", this.TaxPersens.current.value);
    parameter.append("TAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("TOTALAMOUNT", this.valueTax.current.value);

    parameter.append(
      "DEBTBALANCE",
      this.CreditCode_code.current.value !== "C00"
        ? this.valueTax.current.value
        : ""
    );

    parameter.append("DEBTAMOUNT", this.TotalPrice.current.value);
    parameter.append("DOCTYPE", this.state.BuyType_code);
    let DUEDATE = Moment(this.state.DueDate, "DD/MM/YYYY")
      .add(-543, "year")
      .format("YYYY-MM-DD");
    parameter.append("DUEDATE", DUEDATE);
    parameter.append("PAYMENTDATE", DUEDATE);
    parameter.append("TexDate", this.state.TexDate);

    parameter.append(
      "DISCAMOUNT",
      checkData("text", this.Discount.current.value)
    );
    parameter.append("ArCode2", checkData("text", this.state.ufcutomercode));
    parameter.append("Ref_docno", checkData("text", this.state.ufrefdocno));
    parameter.append(
      "Car_Number",
      checkData("text", this.state.ufcarnumberplates)
    );
    parameter.append("Kilo_metter", checkData("text", this.state.ufKilometter));
    parameter.append("BATHSUMAMOUNT1", this.ProductValue.current.value);

    parameter.append("PS_Brand", checkData("text", this.state.brandname));
    parameter.append("PS_Model", checkData("text", this.state.model));
    parameter.append("PS_Color", checkData("text", this.state.colorcar));
    parameter.append(
      "PS_Serialnumber",
      checkData("text", this.state.ufserialnumber)
    );
    parameter.append(
      "PS_Chassisnumber",
      checkData("text", this.state.ufserialnumber)
    );

    //ยอดเงินสดจ่าย
    //เงินสด
    parameter.append("CASHAMOUNT", checkData("money", this.state.CashReceipt));
    //เงินทดลองจ่าย
    parameter.append("POSTBALANCE", POSTBALANCE);
    parameter.append(
      "ADVANCEPAYBAL",
      this.state.Advanceamount ? this.state.Advanceamount : ""
    );
    parameter.append(
      "ADVANCEPAY",
      this.state.Advanceamount ? this.state.Advanceamount : ""
    );
    parameter.append(
      "PETTYCASHCODE",
      this.state.Pettycashcode ? this.state.Pettycashcode : ""
    );
    parameter.append(
      "PETTYCASH",
      this.state.Pettycash ? this.state.Pettycash : "0"
    );
    //จ่ายเงินโอนผ่านบัญชี
    parameter.append("BOOKNO", checkData("text", this.state.Bookno));
    parameter.append("BANKAMOUNT", checkData("money", this.state.Bankamount));
    parameter.append("BANKEXPEND", checkData("money", this.state.Bankexpend));
    parameter.append("BOOKDESC", checkData("text", this.state.Bookdesc));
    // เช็คธนาคาร
    parameter.append("CSPAYCHQ", JSON.stringify(this.state.Cchqs));
    parameter.append(
      "CHEQUEAMOUNT",
      typeof this.state.Cchqssum === "undefined" ? "0" : this.state.Cchqssum
    );
    parameter.append("CSRECINCOME", JSON.stringify(this.state.Income));
    parameter.append(
      "INCOMEAMOUNT",
      !this.state.Incomesum ? "" : this.state.Incomesum
    );
    parameter.append("CSRECEXPENSE", JSON.stringify(this.state.Expenses));
    parameter.append("EXPENDAMOUNT", this.state.Expensessum);

    parameter.append("PROJECT", this.state.PROJECT);
    parameter.append(
      "BATHTAXAMOUNT",
      checkData("money", this.TaxPrice.current.value)
    );
    parameter.append(
      "BATHTOTALAMOUNT",
      checkData("money", this.valueTax.current.value)
    );
    parameter.append("COMPNAME", window.location.hostname);
    parameter.append("CALCWTAX", "0");
    parameter.append("provenance", "web");
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[0] === "APCODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสเจ้าหนี้" });
        return;
      } else if (pair[1] === "" && pair[0] === "APNAME") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาตรวจสอบชื่อเจ้าหนี้" });
        return;
      } else if (pair[0] === "DOCGROUP" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });
        return;
      } else if (pair[0] === "DEPARTMENT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก" });
        return;
      } else if (pair[0] === "PRODUCT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรายการสินค้า" });
        return;
      }
    }

    if (Uststus === true) {
      //console.log("check xxxxxxxxxxxxxxx", genURL("CSPURCHASE/Save?"));
      this.setState({ openBackdrop: true });
      await axios
        .post(genURL("CSPURCHASE/Save?"), parameter)
        .then((res) => {
          //   await axios.post(genpostURLTEST("/Save?user="), parameter).then(res => {
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            this.setState({ openBackdrop: false });
            setTimeout(() => {
              this.ResetThisPage("SAVE");
            }, 100);
          } else {
            setTimeout(() => {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: res.data });
              this.setState({ openBackdrop: false });
            }, 100);
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        });
    }
  };
  Get_PopupApcode = (APCode, APName, Creditcode, Texttype) => {
    this.CloseDialog(false);
    this.APCode.current.value = APCode;
    this.APName.current.value = APName;
    this._pricetype(Texttype);
    setTimeout(() => {
      this.CreditCode_code.current.value = Creditcode;
      this.CreditCode.current.value = CreditCode(Creditcode);
      var dateP = parseFloat(Creditcode.substring(1));
      var BuyDate1 = new Date();
      this.setState({ DueDate: this.CalendarOnChange(BuyDate1, dateP) });
    }, 30);
  };
  _pricetype = (Texttype) => {
    console.log(Texttype);
    this.setState({ defaultselect: [Texttype] });
    this.setState({ PriceType_code: String(Texttype) });
    setTimeout(() => {
      this.ReLoadData();
    }, 300);
  };
  _cellButton_BTNunitname = (cell, row, enumObject, rowIndex) => {
    return this._cellButtonWH(row.BTN_unitname, "Inunitname", rowIndex);
  };
  _cellButtonWH = (btn, file, rowIndex) => {
    var btnShow = "";
    if (file === "Inunitname") {
      switch (btn) {
        case 1:
          btnShow = (
            <div
              style={{ cursor: "pointer", fontSize: "14px" }}
              onClick={() => {
                this.setState({ WHRow: rowIndex });
              }}
            >
              <SelectFix_UNIT getUnit_Table={this.getUnit_Table} />
            </div>
          );
          break;
        case 2:
          btnShow = (
            <div style={{ cursor: "pointer" }}>
              {" "}
              <i
                className="far fa-trash-alt"
                style={{ fontSize: "14px" }}
              ></i>{" "}
            </div>
          );
          break;
        default:
          btnShow = <i></i>;
          break;
      }
    }
    return <div>{btnShow}</div>;
  };
  getUnit_Table = (data) => {
    var r = this.state.WHRow;
    var Pr = this.state.products;
    Pr[r].unitname = data;
    this.setState({ products: Pr });
  };
  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "Calendar":
        this.setState({ BuyDate: data2 });
        break;
      case "Calendar1":
        this.setState({ TexDate: data2 });
        break;
      case "Calendar2":
        console.log(data2);
        this.setState({ DueDate: data2 });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data2 });
        break;
      case "PriceType":
        this.setState({ PriceType_code: data2 });

        try {
          this.ReLoadData();
        } catch (error) {}
        break;
      case "BuyType":
        this.setState({ BuyType_code: data2 });
        break;

      case "brandname":
        this.setState({ BuyType_code: data2 });
        break;

      default:
        break;
    }
  };

  GetApcodeonblur = async () => {
    this.setState({ openBackdrop: true });
    var url =
      "CSAP/APCode?apcode=" +
      this.state.APCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          this.APCode.current.value = res.data[0].CODE;
          this.APName.current.value = res.data[0].APNAME;
          this.setState({ APCode: res.data[0].CODE });
          this._pricetype(res.data[0].TAXTYPE);
          this.CreditCode_code.current.value = res.data[0].CREDITCODE;
          this.CreditCode.current.value = CreditCode(res.data[0].CREDITCODE);
          var dateP = Number(res.data[0].CREDITCODE.substring(1));
          var BuyDate1 = new Date();
          this.setState({ DueDate: this.CalendarOnChange(BuyDate1, dateP) });
          this.Groupdata.current.focus();
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.APCode.current.value = "";
          this.APName.current.value = "";
          this.setState({ openBackdrop: false });
          return;
        }
      })
      .then(async (_) => {
        this.setState({ openBackdrop: false });
      })
      .catch((error) => {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "เกิดข้อผิดพลาด" });
        this._chkload("Error" + error);
      });
  };

  Get_Apcode = async (e) => {
    var url = "";
    if (e.key === "Enter") {
      this.setState({ openBackdrop: true });
      var apcode = e.target.value.trim();
      url =
        "CSAP/APCode?apcode=" +
        apcode +
        "&user=" +
        localStorage.getItem("Username");
      console.log(genURL(url));
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length > 0) {
            this.APCode.current.value = res.data[0].CODE;
            this.APName.current.value = res.data[0].APNAME;
            this.setState({ APCode: res.data[0].CODE });
            this._pricetype(res.data[0].TAXTYPE);
            this.CreditCode_code.current.value = res.data[0].CREDITCODE;
            this.CreditCode.current.value = CreditCode(res.data[0].CREDITCODE);
            var dateP = Number(res.data[0].CREDITCODE.substring(1));
            var BuyDate1 = new Date();
            this.setState({ DueDate: this.CalendarOnChange(BuyDate1, dateP) });
            this.Groupdata.current.focus();
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล" });
            this.APCode.current.value = "";
            this.APName.current.value = "";
            this.setState({ openBackdrop: false });
            return;
          }
        })
        .then(async (_) => {
          this.setState({ openBackdrop: false });
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" });
          this._chkload("Error" + error);
        });
    }
  };
  Get_PopUpOther = (data) => {
    this.CloseDialog(false);
    var data = data.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.setState({ DOCGROUP_code: data[0] });
        this.setState({ DOCGROUP_txt: data[1] });
        this.onAddValue("Groupdata", data[0]);
        break;
      case "Department":
        // OnClick
        this.setState({ Department_code: data[0] });
        // OnBlur
        this.setState({ Department_txt: data[1] });
        this.Department_code.current.value = data[0];
        this.Department.current.value = data[1];
        break;
      case "CreditCode":
        this.CreditCode_code.current.value = data[0].toString();
        this.CreditCode.current.value = data[1].toString();
        var dateP = parseFloat(data[0].substring(1));
        var BuyDate1 = new Date();
        this.setState({ DueDate: this.CalendarOnChange(BuyDate1, dateP) });
        break;
      case "Branch":
        // OnClick
        this.setState({ Branch_code: data[0] });
        // OnBlur
        this.setState({ SiteCode_txt: data[1] });
        this.Branch_code.current.value = data[0];
        this.Branch.current.value = data[1];
        break;
      case "EventType":
        this.EventType.current.value = data[1];
        this.setState({ EventType: data[0] });
        break;
      case "typeofcar":
        this.setState({ Typeofcar: data[0] });
        break;
      default:
        break;
    }
  };
  Get_warehouse = (data) => {
    this.CloseDialog(false);
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.WHRow1;
    Pr[r].warehouse = DataValue[0];
    Pr[r].location = DataValue[2];
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 100);
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      // today.setDate(today.getDate() + (DateUp - DateUp))
      today.setDate(today.getDate() + DateUp);
      // console.log(today.setDate(today.getDate() + DateUp))
    }

    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);

    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  CalendarOnChange1 = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    // console.log(today, "test")

    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);

    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };

  getDocgroup = async function (value, type, Fix) {
    // console.log("Groupdata+value" + value)
    let Url =
      "CSDOCGROUP/Code?tablename=CSPURCHASE&code=" +
      value +
      "&user=" +
      localStorage.getItem("Username") +
      "&top=30";
    // console.log(Url)
    await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
      console.log("ssss", res.data);
      if (res.data.length > 0) {
        // console.log("attachment.length", attachment.length);
        this.Groupdata_code.current.value = res.data[0].CODE;
        this.Groupdata.current.value = res.data[0].MYNAMETH;
        this.setState({ DOCGROUP_txt: res.data[0].MYNAMETH });
        this.setState({ DOCGROUP_code: res.data[0].CODE });
        this.TaxPersens.current.value = res.data[0].TAXRATE;
        var CODE = res.data[0].CODE.trim();
        var of_on = this.state.of_on;
        if (!Fix) {
          this.getMAXDOC(CODE, of_on);
        }
      } else {
        this.Groupdata.current.value = "";
        this.Groupdata_code.current.value = "";
        this.setState({ DOCGROUP_code: "" });
        this.DeliNumber.current.value = "";
      }
    });
    //------------------------------------------------------
  };

  getMAXDOC = async function name(CODE, of_on) {
    var Url = "CSMAXDOC/MAXDOC?tablename=CSPURCHASE&code=" + CODE;
    await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
      if (res.data) {
        if (of_on !== 1) {
          this.DeliNumber.current.value = res.data["maxdoc"];
          // this.TaxNumber.current.value = res.data["maxdoc"]
        } else {
        }
      }
    });
  };

  onAddValue = async function (type, value, Fix) {
    if (value) {
      var Url = "";
      switch (type) {
        case "Groupdata":
          this.getDocgroup(value, type, Fix);
          break;
        case "SaleMan":
          Url = "CSUSER/Chkuser?code=" + value + "&user=";
          // GetCorServicei(Url, "icon" + type).then((res) => {

          await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            try {
              if (res.data.length === 1) {
                this.SaleMan.current.value = res.data[0].MYNAMETH;

                this.SaleMan_code.current.value = res.data[0].CODE;
              } else {
                this.SaleMan.current.value = "";
                this.SaleMan_code.current.value = "";
              }
            } catch (error) {
              //...error
            }
          });
          break;
        case "Department":
          Url =
            "CSDEPARTMENT/ByCode?code=" +
            value +
            "&user=" +
            localStorage.getItem("Username");
          await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            if (res.data.length === 1) {
              this.Department.current.value = res.data[0].MYNAMETH;
              this.setState({ Department_txt: res.data[0].MYNAMETH });
              this.Department_code.current.value = res.data[0].CODE;
            } else {
              this.Department.current.value = "";
              this.Department_code.current.value = "";
            }
            return "SS";
          });
          break;
        case "Branch":
          await CheckBranchname(value)
            .then((result) => {
              if (result !== undefined) {
                this.Branch_code.current.value = value;
                this.Branch.current.value = result;
                this.setState({ SiteCode_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.Branch_code.current.value = "";
                this.Branch.current.value = "";
                this.setState({ SiteCode_txt: "" });
              }
            })
            .catch((err) => {
              this.Branch_code.current.value = "";
              this.Branch.current.value = "";
              this.setState({ SiteCode_txt: "" });
              console.log(err);
            });
          break;
        default:
          break;
      }
    }
  };
  /*---------------------------------------------vvvvvvvvvvvvvvv---center---vvvvvvvvvvvvvvv---------------------------------------------*/
  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpItem("Search_Table")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "trClassName";
  };
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.productcode });
    this.setState({ WHRow1: id });
    var Pr = this.state.products;
    var j = rowTable; //30
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });

    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity,
      buyprice = row.buyprice,
      discountword = row.discountword;
    if (col === 10 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(0);
    } else if (col === 11 && buyprice !== "" && buyprice !== undefined) {
      row.buyprice = parseFloat(buyprice).toFixed(0);
    } /* else if (col === 12 && discountword !== "" && discountword !== undefined) {
      row.discountword = parseFloat(discountword).toFixed(0)
    } */

    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_DeliDate = 0;
      Pr[i].btn_DeliDate1 = 0;
    }

    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      if (!this.state.products[i].productcode) {
        j = i;
      }
    } //หา แถวที่ว่างบนสุดใน products Table
    // var CH = false
    // switch (col) {
    // case 4: Pr[id].BTN_C3 = 1 CH = true break
    // case 6: Pr[id].BTN_C4 = 1 CH = true break
    //}

    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 && Pr[id].productcode !== undefined)
    ) {
      this.setState({ col1: true });
      Pr[id].btn1 = 1;
    } else if (
      col === 4 &&
      typeof row.productcode !== "undefined" &&
      row.productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate = 1;
    } else if (
      col === 6 &&
      typeof row.productcode !== "undefined" &&
      row.productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate1 = 1;
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ col: true });
    }

    /* if (col === 3 && row.productcode !== null && row.productcode[0] + "" + row.productcode[1] === "11") {
      this.setState({
        se_Row: row.C0,
        se_PRODUCTCODE: row.productcode,
        se_WAREHOUSE: row.warehouse,
        se_LOCATION: row.location,
      })
    } */

    this.setState({ products: Pr });
  };

  onAfterSaveCell = (row, cellName, cellValue) => {
    //รหัสสินค้า
    var cellValue1 = this.state.cellValue;
    var col = this.state.products;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ ราคา ลด
    let quantity = row.quantity,
      buyprice = row.buyprice,
      discountword = row.discountword;
    if (cellName === "quantity" && quantity !== "") {
      row.quantity = parseFloat(quantity).toFixed(2);
    } else if (cellName === "buyprice" && buyprice !== "") {
      row.buyprice = parseFloat(buyprice).toFixed(2);
    } else if (
      cellName === "location" ||
      (cellName === "warehouse" && cellValue !== "")
    ) {
      let w = Checkwarehousepermission(
        cellName,
        cellValue,
        this.state.userCode,
        row.productcode
      );
      w.then((v) => {
        col[row.C0 - 1].warehouse = v[0];
        col[row.C0 - 1].location = v[1];
        this.setState({
          products: col,
        });
      });
    }

    // ค้นหารหัสสินค้าแบบกรอกข้อมูล
    if (
      cellName === "productcode" &&
      cellValue !== "" &&
      cellValue1 !== cellValue
    ) {
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      this.AddDataTable(cellValue, row.C0 - 1);
      //เรียงข้อมูลใหม่
    } else if (cellName === "productcode" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
      //เรียงข้อมูลใหม่
    } else {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    }
  };

  Get_PopUpItem = (code, data, stockCode) => {
    this.CloseDialog(false);
    this.AddDataTable(code, this.state.TBLastClick - 1, data, stockCode);
  };
  Get_PopUpRefDocno = (data) => {
    this.CloseDialog(false);
    console.log(data);
    var col = this.state.products;
    var j = this.state.products.length - data.length;
    for (var i = 0; i < data.length; i++) {
      for (var c = 0; c < col.length; c++) {
        if (
          col[c].productcode !== data[i].PRODUCTCODE &&
          col[c].productcode === undefined
        ) {
          col[j] = {
            productcode: data[i].PRODUCTCODE,
            productname: data[i].PRODUCTNAME,
            warehouse: data[i].WAREHOUSE,
            location: data[i].LOCATION,
            unitname: data[i].UNIT,
            unitcode: data[i].UNITCODE,
            quantity: data[i].QTY,
            // quantity: data[i].QTY,
            buyprice: parseFloat(0).toFixed(2),
            discountword: 0,
            RefDocno: data[i].DOCNO,
            itemtaxtype: data[i].ITEMTAXTYPE,
            PRODUCTSET: data[i].PRODUCTSET,
            REFQTY: data[i].REFQTY,
            REFLINEID: data[i].REFLINEID,
            REFDOCTYPE: data[i].REFDOCTYPE,
          };
          break;
        } else if (col[c].productcode === data[i].PRODUCTCODE) {
          break;
        }
        // if (col[c].productcode === data[i].PRODUCTCODE ) {
        // break
        // col[c].quantity = parseFloat(Number(col[c].quantity ) + num).toFixed(2)
        // }
      }
      j++;
      this.setState({ products: col });
    }
    setTimeout(() => {
      this.ReLoadData();
    }, 100);
    /* for (var i = 0; i < data.length; i++ ) {
        col[j] = {
          productcode: data[i].PRODUCTCODE,
          productname: data[i].PRODUCTNAME,
          warehouse: data[i].WAREHOUSE,
          location: data[i].LOCATION,
          unitname: data[i].UNIT,
          unitcode: data[i].UNITCODE,
          quantity: data[i].QTY,
          buyprice: parseFloat(0).toFixed(2),
          discountword: parseFloat(0).toFixed(2),
          RefDocno: data[i].DOCNO
        }
        j ++
        this.setState({ products: col })
    }
    setTimeout(() => {
      this.ReLoadData()
    }, 300) */

    /* this.AddDataTable(data, "RefDocno_PR") // RefDocno ใส่เพื่อ ตอน เพิ่มข้อมูลในดาด้า ให้เพิ่ม ปริมารสินค้าที่ได้มาจาก PopUpRefDocno */
  };
  addByBarCode = (e) => {
    if (e.key === "Enter") {
      this.AddDataTable(e.target.value, "");
      this.barcode.current.value = "";
    }
  };

  /* Get_PopUpSERIALNUMBER = (data1, data2) => {
    var dataArray = this.state.products
    dataArray[this.state.se_Row - 1].SERIALNUMBER = data2.SERIALNUMBER
    dataArray[this.state.se_Row - 1].warehouse = data2.WAREHOUSE
    dataArray[this.state.se_Row - 1].location = data2.LOCATION
    this.setState({ products: dataArray })
  } */

  AddDataTable = async (ItemCode, row) => {
    // var refdata = ItemCode
    // if (row === "RefDocno_PR") ItemCode = refdata.PRODUCTCODE // RefDocno ดึงรหัสสินค้าจาก Get_PopUpRefDocno -- PopUpRefDocno

    var col = this.state.products;
    /* รหัสสินค้าซ้ำกันเพิ่มจำนวน ปริมาณ */
    for (var i = 0; i < col.length; i++) {
      if (col[i].Productcode === ItemCode) {
        col[i].quantity = parseFloat(Number(col[i].quantity) + 1).toFixed(2);
        this.setState({ products: col });
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (res) => {
        var j = 0;
        if (row > -1) {
          j = row;
        } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
          j = this.state.TBLastClick - 1;
        } else {
          for (var i = this.state.products.length - 1; i >= 0; i--) {
            // หาจากล่างขึ้นบน
            if (!this.state.products[i].productcode) {
              j = i;
            }
          }
        }
        if (res.data.length > 0) {
          for (let index = 0; index < res.data.length; index++) {
            // var STOCKTYPE = 0
            var SALELASTPRICE = "";
            var TAXTYPE = "";
            var url1 =
              "CSPRODUCT/Code?productset=0&stocktype=&code=" +
              res.data[index].PRODUCTCODE;
            console.log(genURL(url1));
            await axios
              .get(genURL(url1), { timeout: 3600 })
              .then(async (result) => {
                if (result.data.length > 0) {
                  // STOCKTYPE = await result.data[0].STOCKTYPE
                  //SALELASTPRICE = await result.data[0].SALELASTPRICE
                  TAXTYPE = await result.data[0].TAXTYPE;
                }
              });
            var unit = "";
            await checkunit(res.data[index].UNITCODE).then((result) => {
              unit = result;
            });

            // var REFDOCNO_PR = row === "RefDocno_PR" ? refdata.DOCNO : ""
            // RefDocno ใส่ข้อมูลที่ได้จาก PopUpRefDocno
            console.log(res.data[0]);
            col[j] = {
              C0: j + 1,
              productcode: res.data[index].PRODUCTCODE,
              btn1: col[0].btn1,
              productname: res.data[index].PRODUCTNAME,
              warehouse: this.state.defaultwarehouse,
              location: this.state.defaultlocetion,
              unitname: unit,
              unitcode: res.data[index].UNITCODE,
              quantity: res.data[index].PRODUCTSET === 1 ? "" : (1).toFixed(2),
              buyprice: SALELASTPRICE,
              discountword: "",
              discount: "",
              amount: SALELASTPRICE,
              RefDocno: "",
              MaxUnit: res.data[index].STOCKQTY,
              STOCKTYPE: res.data[index].STOCKTYPE,
              // REFDOCNO_PR: REFDOCNO_PR,
              itemtaxtype: TAXTYPE,
              PRODUCTSET:
                res.data[index].PARENTCODE == res.data[0].PRODUCTCODE
                  ? "2"
                  : String(res.data[index].PRODUCTSET), //ถ้าเป็นลูกของสินค้ากลุ่ม == 2
            };
            j++;
            this.setState({ products: col });
            this.ReLoadData();
            // if (ref.data.length === 1 && ref.data[0].PRODUCTSET === 1) {
            //   j++
            //   var url = "CSPRODUCTSET/Code?code=" + ItemCode + "&user=" + localStorage.getItem("Username")
            //   console.log(genURL(url));
            //   await axios.get(genURL(url), { timeout: 3600 }).then(ref2 => {
            //     if (ref2.data && ref2.data.length > 0) {
            //       for (var i = 0; i < ref2.data.length; i++) {
            //         col[j] = {
            //           C0: j + 1,
            //           productcode: ref2.data[i].PRODUCTCODE,
            //           btn1: col[i].btn1,
            //           productname: ref2.data[i].PRODUCTNAME,
            //           warehouse: this.TreaSury.current.value,
            //           location: this.Storagelocation.current.value,
            //           unitname: ref2.data[i].UNITCODE,
            //           quantity: 0,
            //           buyprice: ref2.data[i].AMOUNT,
            //           discountword: ref2.data[i].DISCAMOUNT,
            //           amount: ref2.data[i].AMOUNT - ref2.data[i].DISCAMOUNT,
            //           RefDocno: "",
            //           MaxUnit: ref2.data[i].STOCKQTY,
            //           STOCKTYPE: ref.data[0].STOCKTYPE,
            //         }
            //         if (i === ref2.data.length - 1) {
            //           this.setState({ products: col })
            //           this.ReLoadData()
            //         }
            //         j++
            //       }
            //     }
            //   }).catch(error => {
            //     console.log(error);
            //   });
            // }
          }
        } else {
          col[j] = {
            C0: j + 1,
          };
          this.setState({ products: col });
          this.ReLoadData();
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" });
        }
        // this.setState({products:col})
      })
      .catch((error) => {
        console.log(error);
      });
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 30000);
  };
  //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = (directions) => {
    var col = this.state.products;
    var NewCol = [];
    var j = 0;
    var Ch = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode) {
        if (col[i].productcode[0] + "" + col[i].productcode[1] === "11") {
          Ch++;
        }
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        NewCol[j].BTN_C3 = 1;
        NewCol[j].BTN_C4 = 1;
        NewCol[j].BTN_unitname = 1;
        if (col[i].discountword === "-") {
          NewCol[j].discountword = col[i].buyprice * col[i].quantity;
        } else if (col[i].discountword === "") {
          NewCol[j].discountword = "";
        }
        let str = "" + NewCol[j].discountword;
        var res = str.match("%");
        if (NewCol[j].quantity) {
          if (res) {
            let newstr = str.split("%");
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "test ====" + newstr[0] });
            var num =
              col[i].buyprice * col[i].quantity -
              col[i].buyprice * col[i].quantity * (newstr[0] / 100);
            NewCol[j].amount = num.toFixed(2);
            NewCol[j].discount =
              col[i].buyprice * col[i].quantity * (newstr[0] / 100);
          } else {
            if (
              col[i].discountword * 1 >
              col[i].buyprice * col[i].quantity * 1
            ) {
              NewCol[j].discountword = parseFloat(
                col[i].buyprice * col[i].quantity * 1
              ).toFixed(2);
            }
            if (isNaN(col[i].discountword)) {
              //if input is not a number then here
              // this.setState({ opensnackbar: true })
              // this.setState({ color: "warning" })
              // this.setState({ icon: ErrorIcon })
              // this.setState({ messagealert: "It is not a Number" })
              NewCol[j].discountword = 0;
              this.ReLoadData();
            } else {
              NewCol[j].amount = (
                col[i].buyprice * col[i].quantity * 1 -
                NewCol[j].discountword * 1
              ).toFixed(2);
              if (NewCol[j].discountword) {
                NewCol[j].discount = parseFloat(NewCol[j].discountword).toFixed(
                  2
                );
              }
              NewCol[j].discountword = NewCol[j].discountword;
              //if input is number then here
              // this.setState({ opensnackbar: true })
              // this.setState({ color: "warning" })
              // this.setState({ icon: ErrorIcon })
              // this.setState({ messagealert: "It is a Number" })
            }
          }
        }
        j++;
      }
    }
    if (Ch > 0) {
      this.setState({ Show_SERIALNUMBER: true });
    } else {
      this.setState({ Show_SERIALNUMBER: false });
    }

    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ products: NewCol });
    setTimeout(() => {
      this.Cal_Price();
    }, 300);
    // this.DiscountPersen.current.value  = parseFloat(0).toFixed(2)
    this.Discount.current.value = parseFloat(0).toFixed(2);
  };

  /*----------------------------------------------------------Switch----------------------------------------------------------*/

  Switch_PopUpItem = (e) => {
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาสินค้า-product" });
  };
  Switch_PopupApcode = (e) => {
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP" });
  };
  Switch_OtherPopup = (e) => {
    //ชื่อ
    this.setState({ OtPopupType: e });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
    if (e === "CreditCode") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-creditcode" });
    }
  };
  /*----------------------------------------------------------Switch----------------------------------------------------------*/
  SwitchValue = (ref, type) => {
    if (type === "EnterEvent") {
      var M_data = this[ref].current.value;
      var D_data = this[ref + "_code"].current.value;
      this[ref].current.value = D_data;
      this[ref + "_code"].current.value = M_data;
    } else {
      if ((type === "IN" && this.state.LastRef !== ref) || type === "OUT") {
        var M_data = this[ref].current.value;
        var D_data = this[ref + "_code"].current.value;
        this[ref].current.value = D_data;
        this[ref + "_code"].current.value = M_data;
        this.setState({ LastRef: ref });
      }
      if (type === "OUT" && this.state.LastRef === ref) {
        this.onAddValue(ref, M_data);
        this.setState({ LastRef: "" });
      }
      if (type === "OUT" && this[ref + "_code"].current.value === "") {
        this[ref].current.value = "";
        this[ref + "_code"].current.value = "";
      }
    }
  };
  onChangeData = (e) => {
    var Ref = this.state.LastRef;
    if (e.key === "Enter" && e.target.value !== "") {
      this.onAddValue(Ref, e.target.value).then((res) => {
        this.SwitchValue(Ref, "EnterEvent");
      });
    }
  };
  Cal_Price = (e) => {
    var SumPriceProduct = 0.0;
    var SumPriceProduct1 = 0.0;
    var TaxPersenNumber = Number(this.TaxPersens.current.value);
    var DiscountPersen = this.DiscountPersen.current.value
      ? Number(this.DiscountPersen.current.value)
      : 0;
    //console.log("Cal_Price", TaxPersenNumber )
    var TaxPersen1 = 100 + TaxPersenNumber;
    for (var i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].amount) {
        SumPriceProduct1 += parseFloat(this.state.products[i].amount);
        this.Discount.current.value = parseFloat(
          (SumPriceProduct1 * DiscountPersen) / 100
        ).toFixed(2);
        SumPriceProduct = SumPriceProduct1 - this.Discount.current.value;
      }
    }
    this.SumPrice.current.value = parseFloat(SumPriceProduct1).toFixed(2);
    // setTimeout(() => {
    this.setState({ allpriceforTax_: SumPriceProduct });
    //console.log("Cal_Price", TaxPersenNumber)
    // }, 300)
    var Discount = 0;
    if (this.Discount.current.value !== "") {
      Discount = parseFloat(this.Discount.current.value).toFixed(2);
    }
    this.Discount.current.value = parseFloat(Discount).toFixed(2);
    /* var TaxPersenNumber  = this.TaxPersenNumber .current.value
    if (this.TaxPersenNumber .current.value) {
      TaxPersenNumber  = parseFloat(TaxPersenNumber ).toFixed(2)
    } */
    // this.DiscountPersen.current.value = parseFloat(DiscountPersen).toFixed(2)
    this.TaxPersens.current.value = parseFloat(TaxPersenNumber)
      .toFixed(2)
      .toString();
    //--------------------------------------เช็คประเภทภาษี------------------------------------------
    if (this.state.PriceType_code === "0" || this.state.PriceType_code === 0) {
      //ไม่รวมภาษี
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * TaxPersenNumber) / 100
      ).toFixed(2);
    } else if (
      this.state.PriceType_code === "1" ||
      this.state.PriceType_code === 1
    ) {
      //รวมภาษี
      this.ProductValue.current.value = parseFloat(
        (SumPriceProduct * 100) / 107
      ).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      console.log(
        parseFloat((SumPriceProduct * TaxPersenNumber) / TaxPersen1).toFixed(2),
        "***********"
      );
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * TaxPersenNumber) / TaxPersen1
      ).toFixed(2);
    } else {
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(0).toFixed(2);
    }
    var ValueExcept = 0;
    if (this.ValueExcept.current.value) {
      ValueExcept = parseFloat(this.ValueExcept.current.value).toFixed(2);
    }
    this.ValueExcept.current.value = parseFloat(ValueExcept).toFixed(2);
    this.valueTax.current.value = parseFloat(
      Number(this.ProductValue.current.value) +
        Number(this.TaxPrice.current.value)
    ).toFixed(2);
    this.TotalPrice.current.value = parseFloat(
      Number(this.valueTax.current.value) -
        Number(this.ValueExcept.current.value)
    ).toFixed(2);
    this.setState({ AmountPayable: this.TotalPrice.current.value });
    /* this.TaxPrice.current.value = parseFloat((SumPriceProduct * TaxPersenNumber ) / (TaxPersen1)).toFixed(2) */
  };
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  };
  reChecked = async (RowData) => {
    // console.log("RowData", RowData)
    this.CloseDialog(false);
    this.setState({
      _saveStatus: true,
      typeActoin: "reChecked",
      RecheckedDocno: RowData[0].docno,
      openBackdrop: true,
    });
    this.setRow(rowTable);
    var url = "CSPURCHASE/GetCSPURCHASEbycode?top=300&code=" + RowData[0].docno;
    console.log("reChecked", genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({ rescspurchase: res.data });
          console.log("reChecked res", res);
          // this.setState({ defaultvaluewarehouse: "รหัสคลัง: " + res.data[0].SITECODE + "  รหัสที่เก็บ: " + res.data[0].SITECODE + "001" })
          this.setState({ of_on: 1 });
          if (res.data[0].APCODE) {
            this.APCode.current.value = res.data[0].APCODE;
          }
          if (res.data[0].APNAME) {
            this.APName.current.value = res.data[0].APNAME;
          }
          this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y").then((No) => {
            this.DeliNumber.current.value = res.data[0].DOCNO;
            this.setState({
              DOCGROUP_code: res.data[0].DOCGROUP,
            });
          });
          this.onAddValue("SaleMan", res.data[0].PURCHASECODE);
          this.CreditCode_code.current.value = res.data[0].CREDITCODE;
          this.CreditCode.current.value = CreditCode(res.data[0].CREDITCODE);
          this.REMARK.current.value = res.data[0].REMARK;
          this._pricetype(res.data[0].TAXTYPE);
          this.onAddValue("Department", res.data[0].DEPARTMENT);
          this.onAddValue("Branch", res.data[0].SITECODE);
          this.TaxNumber.current.value = res.data[0].TAXNO;
          this.depositpayment.current.value = res.data[0].DEPOSITPAYMENT;
          this.WTAXAMOUNT.current.value = res.data[0].WTAXAMOUNT;
          this.setState({
            Department_code: res.data[0].DEPARTMENT,
            Branch_code: res.data[0].SITECODE,
            BuyDate: ReDate(res.data[0].DOCDATE),
            TexDate: ReDate(res.data[0].TAXDATE),
            DueDate: ReDate(res.data[0].DUEDATE),
            ufdefaultcodevalue: res.data[0].ArCode2,
            ufdefaultKilomettervalue: res.data[0].Kilometter,
            ufdefaultufcarnumberplates: res.data[0].Car_Number,
            ufdefaultchassisnumbervalue: res.data[0].PS_Chassisnumber,
            ufdefaultserialnumbervalue: res.data[0].PS_Serialnumber,
            ufdefaultrefdocno: res.data[0].Ref_docno,
            defaultbranValue: res.data[0].PS_Brand,
            defaultcolorValue: res.data[0].PS_Color,
            defaultmodelValue: res.data[0].PS_Model,
          });
        }
      })
      .catch((error) => {
        this._chkload("Error" + error);
      })
      .finally((_) => {
        this.loadBrand();
        this.loadColor();
        this.loadModel();
      });

    var url1 =
      "CSPURCHASE/GetCSPURCHASESUBbycode?top=300&code=" + RowData[0].docno;
    await axios
      .get(genURL(url1))
      .then(async (res) => {
        console.log("sssss", res);
        if (res.data.length > 0) {
          var data = this.state.products;
          for (var i = 0; i < res.data.length; i++) {
            var unit = "";
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
            });
            data[i].productcode = res.data[i].PRODUCTCODE;
            data[i].productname = res.data[i].PRODUCTNAME;
            data[i].DeliDate = ReDate(res.data[i].SHIPDATE);
            data[i].warehouse = res.data[i].WAREHOUSE;
            data[i].location = res.data[i].LOCATION;
            data[i].unitcode = res.data[i].UNITCODE;
            data[i].unitname = unit;
            data[i].quantity = res.data[i].QUANTITY;
            data[i].buyprice = res.data[i].UNITPRICE;
            data[i].discountword = Number(res.data[i].DISCAMOUNT);
            data[i].amount = res.data[i].NETAMOUNT;
            data[i].PRODUCTSET = res.data[i].PRODUCTSET;
            // data[i].itemtaxtype =  res.data[i].
            if (i === res.data.length - 1) {
              await this.setState({ products: data });
              await this.Cal_Price();
            }
          }
        }
      })
      .catch((error) => {
        this._chkload("Error" + error);
      });

    await this.setState({
      openBackdrop: false,
    });
  };

  //**  ค้นหายี่ห้อ รุ่น* */*********************************************************** */

  _handleSearch = async (query) => {
    this.setState({ isLoading: true });
    var _url = "";
    var _code = "";
    var _name = "";
    switch (this.state.chkfocus) {
      case "dimension":
        _url = "CSDIMENSION1/getdata?";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "brandname":
        _url = "CSPDSUBGROUP2/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "model":
        _url = "CSPDSUBGROUP4/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "color":
        _url = "/CSPDSUBGROUP5/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
    }
    await axios.get(genURL(_url)).then((res) => {
      // console.log(res)
      if (res !== "error") {
        var element = [];
        for (let index = 0; index < res.data.length; index++) {
          element.push(res.data[index][_code] + " | " + res.data[index][_name]);
        }
        //    console.log(element)
        this.setState({
          isLoading: false,
          options: element,
        });
      }

      return "SS";
    });
  };
  _blurinput = (e) => {
    //  console.log("xxxx" + this.input.current.value)

    var _txtselect = "";
    var _code = "";
    switch (this.state.chkfocus) {
      case "dimension":
        if (e.target.value === "") {
          this.setState({ dimension1: "ค้นหาสี..." });
        }
        _txtselect = "" + this.state.selecteddimension;
        _code = _txtselect.split("|");
        this.setState({ dimension: _code[0].trim() });
        // setTimeout(() => {
        //      console.log("_nametxt" + this.state.dimension)
        // }, 100)
        break;
      case "brandname":
        if (e.target.value === "") {
          this.setState({ brandname1: "ค้นหาสี..." });
        }
        _txtselect = "" + this.state.selectedbrandname;
        _code = _txtselect.split("|");
        this.setState({ brandname: _code[0].trim() });
        setTimeout(() => {
          console.log("_nametxt" + this.state.brandname);
        }, 100);
        break;
      case "model":
        if (e.target.value === "") {
          this.setState({ model1: "ค้นหารุ่น..." });
        }
        _txtselect = "" + this.state.selectedmodel;
        _code = _txtselect.split("|");
        this.setState({ model: _code[0].trim() });
        // setTimeout(() => {
        //      console.log("_nametxt" + this.state.dimension)
        // }, 100)
        break;
      case "color":
        // console.log("ssss");
        if (e.target.value === "") {
          this.setState({ color1: "ค้นหาสี..." });
        }
        _txtselect = "" + this.state.selectedcolor;
        _code = _txtselect.split("|");
        this.setState({ colorcar: _code[0].trim() });
        break;
    }
    // setTimeout(() => {
    //     console.log("dimension" + this.state.dimension)
    // }, 100)
  };
  //*** */**************************************************************************** */
  _cellButton_btn_DeliDate = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_DeliDate1 = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  Switch_PopUpwarehouse = (type) => {
    // console.log("case setwarehousetable")
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          this.setState({ PopUpWHType: type });
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }
        break;
    }
  };
  ClickAll = (e) => {
    var Name = e.target.name;
    //console.log(Name)
    switch (Name) {
      case "Groupdata":
        this.setState({ Groupdata: this.state.DOCGROUP_code });
        this.Groupdata.current.value = this.state.DOCGROUP_code;
        break;

      case "Department":
        this.setState({ Department: this.state.Department_code });
        this.Department.current.value = this.state.Department_code;
        /* console.log(this.state.Department_code,"มายัง") */
        break;
      case "Branch":
        this.Branch.current.value = this.Branch_code.current.value;
        break;
      /* default: break */
    }
  };
  onBlur = (e) => {
    /* กลุ่มข้อมูล */
    this.Groupdata.current.value = this.state.DOCGROUP_txt;
    /* แผนก */
    this.Department.current.value = this.state.Department_txt;
    /* สาขา */
    this.Branch.current.value = this.state.SiteCode_txt;

    if (
      this.state.PriceType_code !== "2" &&
      e.target.name === "TaxNumber" &&
      e.target.value !== ""
    ) {
      try {
        this.checktaxon(e.target.value).then((result) => {
          console.log("tessssssssssssssssssssssssssss", result.data.length);
          if (result.data.length > 0) {
            console.log("tessssssssssssssssssssssssssss", result);
            this.TaxNumber.current.value = "";
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert: "เลขที่ใบกำกับภาษีซ้ำกรุณาตราจสอบใหม่อีกครั้ง",
            });
          }
        });
      } catch (error) {}
    }
  };
  checktaxon = async (taxno) => {
    // เช็คเลขที่ใบกำกับภาษี
    let checktaxnourl = "CSINPUTTAX/Checktaxno?taxno=" + taxno;
    console.log("genURL(checktaxnourl)", genURL(checktaxnourl));
    let res = axios.get(genURL(checktaxnourl));
    return typeof res !== "undefined" ? res : "";
  };
  onChange = (e) => {
    if ((e.target.name === "APCode") & (e.target.value === "")) {
      this.APCode.current.value = "";
      this.APName.current.value = "";
      this.CreditCode_code.current.value = "";
      this.CreditCode.current.value = "";
      this.setState({ DueDate: this.CalendarOnChange(new Date()) });
    }
    switch (e.target.name) {
      case "Department":
        if (e.target.value === "") {
          this.Groupdata.current.value = "";
          this.state.Department_txt = "";
          this.state.Department_code = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.Branch_code.current.value = "";
          this.Branch.current.value = "";
          this.state.SiteCode_txt = "";
        }
        break;
      case "Groupdata":
        if (e.target.value === "") {
          this.Groupdata.current.value = "";
          this.DeliNumber.current.value = "";
          this.state.DOCGROUP_code = "";
          this.state.DOCGROUP_txt = "";
        }
        break;
      case "ARCode":
        if (e.target.value === "") {
          this.ARCode.current.value = "";
          this.ARName.current.value = "";
        }
        break;

      default:
        break;
    }
  };
  /* Enter */
  _checkDocgroup = async (e) => {
    // console.log(e.key)
    if (e.key === "Enter") {
      //  this.setState({ openBackdrop: true })
      this.getDocgroup(e.target.value, "", "");
    }
  };
  onClickDocNo = () => {
    if (this.state.DOCGROUP_code) {
      var url =
        "CSMAXDOC/MAXDOC?tablename=CSPURCHASE&code=" +
        this.state.DOCGROUP_code.trim();
      var of_on = this.state.of_on;
      // console.log(genURL(url));
      axios.get(genURL(url)).then((res) => {
        if (res.data !== undefined) {
          if (of_on !== 1) {
            this.DeliNumber.current.value = res.data.maxdoc;
            this.setState({ openBackdrop: false });
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.setState({ openBackdrop: false });
          this.DeliNumber.current.value = "";
        }
      });
    } else {
      this.DeliNumber.current.value = "";
      this.setState({ openBackdrop: false });
    }
  };
  _checkDepartmant = async (e) => {
    if (e.key === "Enter") {
      this.setState({ openBackdrop: true });
      var url =
        "CSDEPARTMENT/ByCode?code=" +
        e.target.value +
        "&user=" +
        localStorage.getItem("Username");
      //   console.log(genURL(url));
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length > 0) {
            this.setState({ Department_txt: res.data[0].MYNAMETH });
            this.setState({ Department_code: res.data[0].CODE });
            this.setState({ Department: res.data[0].MYNAMETH });
            this.Department.current.value = res.data[0].MYNAMETH;
            this.Department_code.current.value = res.data[0].CODE;
          } else {
            this.setState({ openBackdrop: false });
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล" });
            this.setState({ Department_txt: "" });
            this.setState({ Department_code: "" });
            this.Department.current.value = "";
            this.Department_code.current.value = "";
          }
        })
        .then(async (_) => {
          this.setState({ openBackdrop: false });
        })
        .catch((error) => {
          this._chkload("Error" + error);
          this.setState({ openBackdrop: false });
        });
    }
  };
  _checkSitecode = async (e) => {
    if (e.key === "Enter") {
      this.setState({ openBackdrop: true });
      let url =
        "CSSITE/Getsite?Code=" +
        e.target.value +
        "&user=" +
        localStorage.getItem("Username");
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length === 1) {
            this.setState({ SiteCode_txt: res.data[0].MYNAMETH });
            this.setState({ Branch_code: res.data[0].CODE });
            this.Branch.current.value = res.data[0].MYNAMETH;
            this.Branch_code.current.value = res.data[0].CODE;
            this.setState({ openBackdrop: false });
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล" });
            this.setState({ SiteCode_txt: "" });
            this.setState({ SiteCode_code: "" });
            this.Branch.current.value = "";
            this.Branch_code.current.value = "";
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this._chkload("Error" + error);
          this.setState({ openBackdrop: false });
        });
    }
  };
  openlistPR = (e) => {
    if (this.APCode.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้" });
      return;
    } else {
      //ชื่อ
      this.setState({ typeFullScreenDialog: e });
      //open
      this.setState({ openFullScreenDialog: true });
      //title
      this.setState({
        titleFullScreenDialog: "ค้นหาใบขอสั่งซื้อสินค้า-SelPRRef",
      });
    }
  };
  onClickTopbar = async (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._connectsaveData();
        break;
      case "new":
        window.location.reload();
        break;
      case "print":
        console.log("print");
        break;
      case "search":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "บันทึกซื้อสินค้าและบริการ" });
        break;
      case "SelPRRef":
        this.openlistPR(e);
        break;

      case "MoneyExp":
        // this.setState({ PopUpSaveMoney: true })
        // this.setState({ parm: Data })

        await this.setState({ typeFullScreenDialog: "MoneyExp" });
        await this.setState({ titleFullScreenDialog: "บันทึกจ่ายเงิน" });
        await this.setState({ openFullScreenDialog: true });

        break;

      default:
        break;
    }
  };

  propsvalue = (data) => {
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };

  // new Autocomplete input

  loadBrand = async (val) => {
    // for check loading data
    this.setState({
      typeLoad: val,
      isLoadingchoicebarnd: "กำลังโหลดข้อมูลกรุณารอสักครู่...",
    });

    let url = "CSPDSUBGROUP2/getAll?top=1000?";
    let item = [];
    await axios.get(genURL(url)).then((res) => {
      if (res.data.length > 0) {
        for (let index = 0; index < res.data.length; index++) {
          item.push({
            CODE: res.data[index].CODE,
            MYNAMETH: res.data[index].CODE + ":" + res.data[index].MYNAMETH,
          });
        }
      }
    });
    await this.setState({ choicebrandData: item, isLoadingchoicebarnd: "" });
  };

  loadModel = async (val) => {
    // for check loading data
    this.setState({
      typeLoad: val,
      isLoadingchoiceModel: "กำลังโหลดข้อมูลกรุณารอสักครู่...",
    });

    let url = "CSPDSUBGROUP4/getAll?top=2000";
    let item = [];
    await axios.get(genURL(url)).then((res) => {
      if (res.data.length > 0) {
        for (let index = 0; index < res.data.length; index++) {
          item.push({
            CODE: res.data[index].CODE,
            MYNAMETH: res.data[index].CODE + ":" + res.data[index].MYNAMETH,
          });
        }
      }
    });
    await this.setState({ choicemodelData: item, isLoadingchoiceModel: "" });
  };

  loadColor = async (val) => {
    // for check loading data
    this.setState({
      typeLoad: val,
      isLoadingchoiceColor: "กำลังโหลดข้อมูลกรุณารอสักครู่...",
    });

    let url = "CSPDSUBGROUP5/getAll?top=2000";
    let item = [];
    await axios.get(genURL(url)).then((res) => {
      if (res.data.length > 0) {
        for (let index = 0; index < res.data.length; index++) {
          item.push({
            CODE: res.data[index].CODE,
            MYNAMETH: res.data[index].CODE + ":" + res.data[index].MYNAMETH,
          });
        }
      }
    });
    await this.setState({ choicecolorData: item, isLoadingchoiceColor: "" });
  };

  onUseAutocompleteactivate = (val) => {
    console.log("onUseAutocompleteactivate", val);
    // this.setState({ choiceData: [] })

    if (val === "brand") {
      if (this.state.typeLoad !== val) {
        this.loadBrand(val);
      }
    } else if (val === "type") {
      this.loadType();
    } else if (val === "model") {
      this.loadModel();
    } else if (val === "status") {
      this.loadStatus();
    } else if (val === "color") {
      this.loadColor();
    } else if (val === "dimension1") {
      this.loadDimension1();
    } else if (val === "warehouse") {
      this.loadWarehouse();
    } else if (val === "location") {
      this.loadLocation();
    } else if (val === "sitecode") {
      this.loadSite();
    } else if (val === "pettycashcode") {
      this.loadPettycashcode();
    } else if (val === "carnumber") {
      this.loadCarnumber();
    }
  };

  setvalue = async (e, type) => {
    console.log("setvalue type", type, "val ", e[0].CODE);
    switch (type) {
      case "carnumber":
        this.setState({ ufcarnumberplates: e[0].CODE });
        break;

      case "brand":
        this.setState({ brandname: e[0].CODE });
        break;
      case "model":
        this.setState({ model: e[0].CODE });
        break;
      case "color":
        this.setState({ colorcar: e[0].CODE });
        break;

      default:
        break;
    }
  };
  // end Autocomplete input

  // CustomInputhandleBlur

  CustomInputhandleBlur = (e, type) => {
    switch (type) {
      case "Kilometter":
        this.setState({ ufKilometter: e });
        break;

      case "ufcutomercode":
        this.setState({ ufcutomercode: e });
        break;
      case "ufrefdocno":
        this.setState({ ufrefdocno: e });
        break;

      case "serialnumber":
        this.setState({ ufserialnumber: e });
        break;

      case "chassisnumber":
        this.setState({ ufchassisnumber: e });
        break;
      default:
        break;
    }
  };

  loadCarnumber = async () => {
    // https://psaccmdapi.pspl.co.th/CSCARNUMBER/Getcarnumber?api_key=JmeD3lEvTKVOp0pKPJwHsbGKGDAdZlo5cwbrhsYc&jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NDg4MTI4NzgsIlVzZXIiOnsiQ09ERSI6IjUxMjUyIiwiU0lURUNPREUiOiI3MDI4IiwiVVNFUkdST1VQIjoiMDEifX0.0bqZCwXSRebJxsP7lnCknP2dPcAjgYsNI3QFuWXBmTQ
    let url = "CSCARNUMBER/Getcarnumber?";
    console.log("CSCARNUMBER", genURL(url));
    let res = await axios.get(genURL(url), { timeout: 12000 });
    //  label: 'The Lord of the Rings: The Two Towers'
    console.log("CSCARNUMBER", res);
    var elementcarnumber = [];
    if (res.data.length > 0) {
      for (let index = 0; index < res.data.length; index++) {
        elementcarnumber.push({
          CODE: res.data[index].CODE,
          MYNAMETH: res.data[index].MYNAMETH,
        });
      }
    }
    //   this.setState({ "carnumber": res.data })
    await this.setState({
      carnumber: elementcarnumber,
    });
  };
  render() {
    const type = this.state.typeFullScreenDialog;
    return (
      <div className="PSApp" onChange={this.onChange} onBlur={this.onBlur}>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "MoneyExp" ? (
            <PopUpSaveMoneyExp
              closePopup={(e) => this.CloseDialog(e)}
              AmountPayable={
                typeof this.state.AmountPayable !== "undefined"
                  ? this.state.AmountPayable
                  : "0.00"
              }
              date={this.state.BuyDate}
              Customer={this.APCode.current.value}
              from="CSPURCHASE"
              pms="R|1|1|1|1|1|1"
              get_PopUpSaveMoney={this.get_PopUpSaveMoney}
              recheckeddata={this.state.rescspurchase}
            />
          ) : null}
          {type === "search" ? <Rechecked Dataselect={this.reChecked} /> : null}
          {type === "Search_APCode" ? (
            <PopupApcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopupApcode={this.Get_PopupApcode}
            />
          ) : null}
          {type === "Groupdata" ||
          type === "Department" ||
          type === "Branch" ||
          type === "CreditCode" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSPURCHASE"
              userSite={""}
            />
          ) : null}
          {type === "Search_Table" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              userSite={this.state.siteCodeUser}
              from="CSPURCHASE"
            />
          ) : null}
          {type === "setwarehousetable" ? (
            <PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type="setdefaultwarehouse"
              Get_PopUpOther={this.Get_warehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSPURCHASE"
            />
          ) : null}
          {type === "SelPRRef" ? (
            <PopUpRefDocno
              closePopup={(e) => this.CloseDialog(e)}
              Title="SelPRRef"
              Get_PopUpRefDocno={this.Get_PopUpRefDocno}
            />
          ) : null}
        </FullScreenDialog>
        <Topbar
          listmenu={listmenu}
          title="บันทึกซื้อสินค้าและบริการ"
          onClick={(e) => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group ">
                  <span className="input-group-addon">รหัสเจ้าหนี้ </span>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.APCode}
                    name="APCode"
                    tabIndex={1}
                    onKeyDown={this.Get_Apcode}
                    //onBlur={this.GetApcodeonblur}
                  />
                  <span
                    onClick={() => this.Switch_PopupApcode("Search_APCode")}
                    id="iconAPCode"
                    className="input-group-addon icon"
                  >
                    {/* <i > <ArrowDropDownRoundedIcon fontSize="small"/></i> */}
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon
                        fontSize="small"
                        style={{ cursor: "hand" }}
                      />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={8}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">ชื่อ-นามสกุล </span>
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    ref={this.APName}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">กลุ่มข้อมูล </span>
                  <input
                    type="text"
                    className="form-control hidden"
                    ref={this.Groupdata_code}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="Groupdata"
                    ref={this.Groupdata}
                    tabIndex={2}
                    onClick={this.ClickAll}
                    onKeyDown={this._checkDocgroup}
                    onBlur={this.Onblur}
                  />
                  <span
                    id="iconGroupdata"
                    className="input-group-addon icon"
                    onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}
                  >
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon
                        fontSize="small"
                        style={{ cursor: "hand" }}
                      />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่ซื้อ"
                DateValue={(e) => this.SelectSetData("Calendar", e)}
                defaultdate={this.state.BuyDate}
                open={
                  true
                  //this.state.checkenableInput['DOCDATE']
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">เลขที่เอกสาร </span>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.DeliNumber}
                    disabled
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">ใบกำกับภาษี </span>
                  <input
                    type="text"
                    className="form-control"
                    name="TaxNumber"
                    ref={this.TaxNumber}
                    readOnly={this.state.checkenableInput["TaxNo"] ? 0 : 1}
                    maxLength="30"
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่ใบกำกับ"
                DateValue={(e) => this.SelectSetData("Calendar1", e)}
                defaultdate={this.state.TexDate}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">รหัสเครดิต </span>
                  <input
                    type="text"
                    className="form-control hidden"
                    ref={this.CreditCode_code}
                  />
                  <input
                    type="text"
                    className="form-control"
                    ref={this.CreditCode}
                    onKeyPress={this.onChangeData.bind(null)}
                    onBlur={this.SwitchValue.bind(null, "CreditCode", "OUT")}
                    onFocus={this.SwitchValue.bind(null, "CreditCode", "IN")}
                    disabled
                  />
                  <span
                    id="iconCreditCode"
                    className="input-group-addon icon"
                    onClick={this.Switch_OtherPopup.bind(null, "CreditCode")}
                  >
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon
                        fontSize="small"
                        style={{ cursor: "hand" }}
                      />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <MaterialUIPickers
                title="ครบกำหนด"
                DateValue={(e) => this.SelectSetData("Calendar2", e)}
                defaultdate={this.state.DueDate}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <SelectDatas
                    origin="PriceType" // ประเภท
                    valueSelect={(e) => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                    title="ประเภทราคา"
                    defaultselect={this.state.defaultselect} // ค่าเริ่มต้นของ ประเภทราคา
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <CustomInputtext
                title="คลังเริ่มต้น"
                value={this.state.defaultvaluewarehouse}
                disabledvalue={true}
                of_title={false}
                of_btn={false}
                source={"CSWAREHOUSEALL"}
                propsvalue={this.propsvalue}
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
        <div className="container-fluid">
          <div className=" PSAppTable ">
            <BootstrapTable
              data={this.state.products}
              trClassName="trClassName"
              tableHeaderClass="trClassName"
              options={{ noDataText: "...", onRowClick: this.onRowClick }}
              cellEdit={{
                mode: "click",
                blurToSave: true,
                beforeSaveCell: this.onBeforeSaveCell,
                afterSaveCell: this.onAfterSaveCell,
              }}
              /* ไม่ให้พิมพ์ข้อมูลได้ */
              /* keyBoardNav={{ enterToEdit: true }} */
              height="400"
              /* striped */
              hover
            >
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="C0"
                isKey
                width="35"
                dataAlign="center"
                dataFormat={this._chkload.bind(this)}
              >
                {" "}
                {/* <i className="fas fa-plus" style={{fontSize:"10px"}} onClick={this.Switch_PopUpItem}></i>this.state.C1_editable */}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                headerAlign="center"
                className="colbuttomhidden"
                width="30%"
              >
                {" "}
                รหัสสินค้า
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="productcode"
                editable={this.state.col1}
                dataAlign="left"
                width="130"
              >
                {" "}
                <div align="center"></div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Btn1"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="productname"
                editable={false}
                dataAlign="left"
                width="130"
              >
                {" "}
                <div align="center"> ชื่อสินค้า </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                width="10%"
                className="colbuttomhidden"
              >
                {" "}
                คลัง{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="warehouse"
                editable={this.state.col}
                dataAlign="center"
                width="80"
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="BTN_C3"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_DeliDate.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                width="130"
                className="colbuttomhidden"
              >
                {" "}
                ตำแหน่งเก็บ
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="location"
                editable={this.state.col}
                dataAlign="center"
                width="80"
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="BTN_C4"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_DeliDate1.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="unitname"
                editable={false}
                dataAlign="center"
                width="90"
              >
                {" "}
                หน่วย
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="unitcode"
                dataAlign="center"
                hidden
              >
                unitcode
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="quantity"
                editable={this.state.col}
                dataAlign="center"
                width="90"
              >
                {" "}
                ปริมาณ
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="buyprice"
                editable={this.state.col}
                dataAlign="right"
                width="90"
              >
                {" "}
                ราคาซื้อ
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="discountword"
                editable={this.state.col}
                dataAlign="right"
                width="90"
              >
                {" "}
                <div align="center"> ลด </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="discount"
                editable={false}
                dataAlign="right"
                width="90"
              >
                {" "}
                ลด(จำนวนเงิน)
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="amount"
                editable={false}
                dataAlign="right"
                width="90"
              >
                {" "}
                <div align="center"> จำนวนเงิน </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="RefDocno"
                editable={this.state.col}
                dataAlign="right"
                width="140"
              >
                {" "}
                <div align="center"> อ้างอิง </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="itemtaxtype"
                editable={this.state.col}
                dataAlign="right"
              >
                {" "}
                <div align="center" hidden>
                  {" "}
                  itemtaxtype{" "}
                </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="PRODUCTSET"
                width="90"
                editable={false}
                hidden
              >
                PRODUCTSET
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="REFLINEID"
                width="90"
                editable={false}
                hidden
              >
                REFLINEID
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="REFDOCTYPE"
                width="90"
                editable={false}
                hidden
              >
                REFDOCTYPE
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
        <div className="PSAppfrom">
          <Grid container rowSpacing={1} direction="row">
            <Grid
              container
              rowSpacing={1}
              direction="row"
              xs={12}
              sm={12}
              md={8}
              lg={8}
              xl={8}
            >
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">พนักงานจัดซื้อ </span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.SaleMan_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      ref={this.SaleMan}
                      disabled
                    />
                    <span className="input-group-addon icon">
                      <i className="fab fa-expeditedssl"></i>
                    </span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">แผนก </span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Department_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="Department"
                      ref={this.Department}
                      tabIndex={3}
                      onClick={this.ClickAll}
                      onKeyDown={this._checkDepartmant}
                    />
                    <span
                      id="iconDepartment"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "Department")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon
                          fontSize="small"
                          style={{ cursor: "hand" }}
                        />
                      </i>
                    </span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="PROJECT" // โครงการ
                      valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                      title="โครงการ"
                      defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                    />
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">สาขา </span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Branch_code}
                    />
                    <input
                      type="text"
                      className="form-control "
                      name="Branch"
                      ref={this.Branch}
                      tabIndex={4}
                      onClick={this.ClickAll}
                      onKeyDown={this._checkSitecode}
                    />
                    <span
                      id="iconBranch"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "Branch")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon
                          fontSize="small"
                          style={{ cursor: "hand" }}
                        />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">หักเงินมัดจำ </span>
                    <input
                      type="number"
                      className="form-control"
                      ref={this.depositpayment}
                      readOnly
                    />
                    <span className="input-group-addon icon"></span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">หัก ณ ที่จ่าย </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.WTAXAMOUNT}
                    />
                    <span className="input-group-addon icon"></span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="BuyType" // ประเภท
                      valueSelect={(e) => this.SelectSetData("BuyType", e)} // รับค่ากลับ
                      title="ประเภทการซื้อ"
                      defaultselect={this.state.BuyType_code} // ค่าเริ่มต้นของ ประเภทราคา
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">หมายเหตุ </span>
                    <input
                      type="text"
                      className="form-control"
                      ref={this.REMARK}
                      tabIndex={6}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} container rowSpacing={1} direction="row">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">สกุลเงิน </span>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue="บาท"
                      />
                      <span className="input-group-addon icon">
                        <i></i>
                      </span>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">
                        อัตราแลกเปลี่ยน{" "}
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        defaultValue="1.00"
                      />
                      <span className="input-group-addon icon"></span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-addon">รวมจำนวนเงิน </span>
                  <input
                    type=""
                    className="form-control Price"
                    ref={this.SumPrice}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-addon">ส่วนลด </span>
                  <input
                    type="number"
                    /* min="1" max="200" */ className="form-control Price"
                    ref={this.DiscountPersen}
                    onClick={(e) => {
                      e.target.value = parseFloat(e.target.value).toFixed(0);
                    }}
                    onKeyDown={this.Cal_Price1}
                    onBlur={this.Cal_Price.bind(null)}
                  />
                  <span className="input-group-addon icon">
                    <i className="fas fa-percentage"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.Discount}
                    disabled
                    tabIndex={5}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-addon">มูลค่าสินค้า </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.ProductValue}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-addon">ภาษีมูลค่าเพิ่ม </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.TaxPersens}
                    onClick={(e) => {
                      e.target.value = parseFloat(e.target.value).toFixed(0);
                    }}
                    onKeyDown={this.Cal_Price1}
                    onBlur={this.Cal_Price.bind(null)}
                  />
                  <span className="input-group-addon icon">
                    <i className="fas fa-percentage"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.TaxPrice}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-addon ">มูลค่ารวมภาษี </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.valueTax}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> มูลค่ายกเว้น </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.ValueExcept}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> รวมเงินทั้งสิ้น </span>
                  <input
                    type="text"
                    className="form-control Price"
                    ref={this.TotalPrice}
                    disabled
                  />
                </div>
              </div>
            </Grid>
          </Grid>

          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h5">
                ข้อมูลเพิ่มเติม ( User's Field){" "}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <Grid container rowSpacing={1} direction="row">
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <CustomInput
                    label="รหัสลูกค้าจริง"
                    id="ufcutomercode"
                    tabIndex={7}
                    inputType="text"
                    resData={(e) =>
                      this.CustomInputhandleBlur(e, "ufcutomercode")
                    }
                    defaultValue={this.state.ufdefaultcodevalue}
                  />

                  <CustomInput
                    label="เลขที่มัดจำจ่าย"
                    id="ufrefdocno"
                    tabIndex={8}
                    inputType="text"
                    resData={(e) => this.CustomInputhandleBlur(e, "ufrefdocno")}
                    defaultValue={this.state.ufdefaultrefdocno}
                  />
                  {/* <CustomInput label="ทะเบียนรถ"
                    id="ufcarnumberplates"
                    tabIndex={9}
                    inputType="text"
                    resData={e => this.CustomInputhandleBlur(e, "ufcarnumberplates")}
                    defaultValue={this.state.ufdefaultufcarnumberplates}
                  /> */}

                  <UseAutocompletes
                    title="ทะเบียนรถ"
                    id="carnumber"
                    datalist={this.state.carnumber}
                    valueReturn={(e) => this.setvalue(e, "carnumber")}
                    activate={(_) => this.loadCarnumber()}
                    placeholder={this.state.cbcdefaultvalue}
                  />
                </Grid>
                <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
                  <>
                    <CustomInput
                      label="ระยะทาง(ไมล์)"
                      id="Kilometter"
                      tabIndex={10}
                      inputType="number"
                      resData={(e) =>
                        this.CustomInputhandleBlur(e, "Kilometter")
                      }
                      defaultValue={this.state.ufdefaultKilomettervalue}
                    />

                    {/* <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon"> ระยะทาง(ไมล์)  </span>
                        <input type="text" className="form-control Price" ref={this.Kilo_metter} tabIndex={10} />
                      </div>
                    </div> */}
                    {this.state.typeActoin === "new" ? (
                      <UseAutocompletes
                        title={"ยี่ห้อ"}
                        id={"brandnameid"}
                        datalist={this.state.choicebrandData}
                        valueReturn={(e) => this.setvalue(e, "brand")}
                        activate={(_) =>
                          this.onUseAutocompleteactivate("brand")
                        }
                        placeholder={this.state.isLoadingchoicebarnd}
                      />
                    ) : typeof this.state.defaultbranValue !== undefined &&
                      this.state.choicebrandData.length > 0 ? (
                      <UseAutocompletes
                        title={"ยี่ห้อ"}
                        id={"brandreachck"}
                        datalist={this.state.choicebrandData}
                        valueReturn={(e) => this.setvalue(e, "brand")}
                        activate={(_) =>
                          this.onUseAutocompleteactivate("brand")
                        }
                        placeholder={this.state.isLoadingchoicebarnd}
                        defaultvalue={this.state.defaultbranValue}
                      />
                    ) : (
                      ""
                    )}

                    {this.state.typeActoin === "new" ? (
                      <UseAutocompletes
                        title={"รุ่น"}
                        id={"modelid"}
                        datalist={this.state.choicemodelData}
                        valueReturn={(e) => this.setvalue(e, "model")}
                        activate={(_) =>
                          this.onUseAutocompleteactivate("model")
                        }
                        placeholder={this.state.isLoadingchoiceModel}
                      />
                    ) : typeof this.state.defaultmodelValue !== undefined &&
                      this.state.choicemodelData.length > 0 ? (
                      <UseAutocompletes
                        title={"รุ่น"}
                        id={"modelrecheck"}
                        datalist={this.state.choicemodelData}
                        valueReturn={(e) => this.setvalue(e, "model")}
                        activate={(_) =>
                          this.onUseAutocompleteactivate("model")
                        }
                        placeholder={this.state.isLoadingchoiceModel}
                        defaultvalue={this.state.defaultmodelValue}
                      />
                    ) : (
                      ""
                    )}
                  </>
                </Grid>

                <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
                  {this.state.typeActoin === "new" ? (
                    <UseAutocompletes
                      title={"สี"}
                      id={"colorid"}
                      datalist={this.state.choicecolorData}
                      valueReturn={(e) => this.setvalue(e, "color")}
                      activate={(_) => this.onUseAutocompleteactivate("color")}
                      placeholder={this.state.isLoadingchoiceColor}
                    />
                  ) : typeof this.state.defaultcolorValue !== undefined &&
                    this.state.choicecolorData.length > 0 ? (
                    <UseAutocompletes
                      title={"สี"}
                      id={"coloridrecheck"}
                      datalist={this.state.choicecolorData}
                      valueReturn={(e) => this.setvalue(e, "color")}
                      activate={(_) => this.onUseAutocompleteactivate("color")}
                      placeholder={this.state.isLoadingchoiceColor}
                      defaultvalue={this.state.defaultcolorValue}
                    />
                  ) : (
                    ""
                  )}

                  <CustomInput
                    label="หมายเลขเครื่อง"
                    id="serialnumber"
                    tabIndex={14}
                    inputType="text"
                    resData={(e) =>
                      this.CustomInputhandleBlur(e, "serialnumber")
                    }
                    defaultValue={this.state.ufdefaultserialnumbervalue}
                  />

                  <CustomInput
                    label="หมายเลขตัวถัง"
                    id="chassisnumber"
                    tabIndex={15}
                    inputType="text"
                    resData={(e) =>
                      this.CustomInputhandleBlur(e, "chassisnumber")
                    }
                    defaultValue={this.state.ufdefaultchassisnumbervalue}
                  />
                </Grid>
              </Grid>
            </Panel.Body>
          </Panel>

          <Snackbar
            place="br"
            color={this.state.color}
            icon={this.state.icon}
            autoClose={this.state.autoClose}
            message={this.state.messagealert}
            open={this.state.opensnackbar}
            closeNotification={() => {
              this.setState({ opensnackbar: false });
            }}
            close
          />
        </div>
      </div>
    );
  }
}
